import React from 'react'

type Option = {
    value: string,
    label: string,
}

type SelectProps = {
    name?: string,
    value?: string,
    onChange?: (value: string) => void,
    data: Option[],
    fullWidth?: boolean,
} & React.SelectHTMLAttributes<HTMLSelectElement>

const selectStyle = {
    background: 'none',
    border: 'none',
    outline: 'none',
    padding: '5px',
    margin: '-7px',
}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
    ({ value, onChange, data, ...rest }, ref) => {
        const { fullWidth, ...newRest } = rest
        const className = fullWidth ? " fullwidth" : ""

        return (
            <div role="combobox" id=":r1d:" aria-haspopup="listbox" aria-expanded="false"
                aria-controls=":r1d:-listbox" aria-describedby=":r1d:-describe"
                className={`rs-btn rs-btn-default${className}`}>
                <select
                    style={selectStyle}
                    ref={ref}
                    value={value}
                    onChange={(e) => onChange?.(e.target.value)}
                    {...newRest}
                >
                    {data.map((item) => (
                        <option key={item.value} value={item.value}>
                            {item.label}
                        </option>
                    ))}
                </select>
            </div>
        )
    }
)
Select.displayName = 'Select'

export default Select